'use strict';

const cardNames = {
    VISA: 'visa',
    MASTERCARD: 'mastercard',
    AMERICAN_EXPRESS: 'american-express',
    DINERS_CLUB: 'diners-club',
    DISCOVER: 'discover',
    JCB: 'jcb',
    MAESTRO: 'maestro',
};

const testOrder = [
    cardNames.VISA,
    cardNames.MASTERCARD,
    cardNames.AMERICAN_EXPRESS,
    cardNames.DINERS_CLUB,
    cardNames.DISCOVER,
    cardNames.JCB,
    cardNames.MAESTRO,
];

const cardTypes = {
    'visa': {
        type: 'visa',
        code: 'VI',
        patterns: [
            4,
        ],
        lengths: [16, 18, 19],
    },
    'mastercard': {
        type: 'mastercard',
        code: 'CA',
        patterns: [
            [51, 55],
            [2221, 2229],
            [223, 229],
            [23, 26],
            [270, 271],
            2720,
        ],
        lengths: [16],
    },
    'american-express': {
        type: 'american-express',
        code: 'AX',
        patterns: [
            34,
            37,
        ],
        lengths: [15],
    },
    'diners-club': {
        type: 'diners-club',
        code: 'DC',
        patterns: [
            [300, 305],
            36,
            38,
            39,
        ],
        lengths: [14, 16, 19],
    },
    'discover': {
        type: 'discover',
        code: 'DS',
        patterns: [
            6011,
            [644, 649],
            65,
        ],
        lengths: [16, 19],
    },
    'jcb': {
        type: 'jcb',
        code: 'JC',
        patterns: [
            2131,
            1800,
            [3528, 3589],
        ],
        lengths: [16, 17, 18, 19],
    },
    'maestro': {
        type: 'maestro',
        code: 'MA',
        patterns: [
            493698,
            [500000, 506698],
            [506779, 508999],
            [56, 59],
            63,
            67,
            6,
        ],
        lengths: [12, 13, 14, 15, 16, 17, 18, 19],
    },
};

module.exports = {
    cardTypes,
    testOrder,
};
